<template>
  <DetailTemplate
    :customClass="'customer-detail detail-page'"
    v-if="getPermission('lead:view')"
  >
    <template v-slot:sidebar-detail>
      <v-card class="h-100" elevation="0">
        <div>
          <ContactDetail
            :pageLoading="pageLoading"
            :lead="leadArr"
          ></ContactDetail>
        </div>
        <template v-if="getPermission('lead:update')">
          <div key="0" class="">
            <template>
              <v-skeleton-loader
                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                v-if="pageLoading"
                type="button"
                height="28"
                width="200"
              >
              </v-skeleton-loader>
              <v-btn
                v-else
                class="custom-bold-button"
                small
                depressed
                v-on:click.native.stop="detailDialog = true"
              >
                <v-icon color="cyan" dark left>mdi-pencil</v-icon>Update Lead
                Details
              </v-btn>
            </template>
          </div>
        </template>
      </v-card>
    </template>
    <template v-slot:header-title>
      <v-skeleton-loader
        class="custom-skeleton"
        v-if="pageLoading"
        width="400"
        height="28"
        type="text"
      >
      </v-skeleton-loader>
      <div class="d-flex">
        <h1
          class="form-title custom-nowrap-ellipsis text-capitalize mr-2"
          v-if="leadArr.company_type == 'company'"
        >
          {{ getPageTitle }}
        </h1>
        <h1
          class="form-title custom-nowrap-ellipsis text-capitalize mr-2"
          v-else
        >
          <template
            v-if="
              leadArr &&
              leadArr.default_person &&
              leadArr.default_person.display_name
            "
            >{{ leadArr.default_person.display_name }}</template
          >
        </h1>
      </div>
    </template>
    <template v-slot:header-action>
      <v-skeleton-loader
        class="custom-skeleton d-inline-block mr-2"
        v-if="pageLoading"
        type="button"
        height="28"
      >
      </v-skeleton-loader>
      <template>
        <div class="d-flex">
          <template v-if="leadArr.converted_to_customer === '0'">
            <v-tooltip bottom content-class="custom-bottom-tooltip">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  depressed
                  :disabled="pageLoading"
                  class="mx-1 custom-bold-button white--text"
                  color="cyan"
                  v-bind="attrs"
                  v-on="on"
                  v-on:click="createTransaction(leadArr, 'convert_to_customer')"
                >
                  <v-icon left>mdi-account-convert</v-icon> Convert to Customer
                </v-btn>
              </template>
              <span>Click here to Convert to Customer</span>
            </v-tooltip>
          </template>

          <v-btn
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="goBack"
            depressed
          >
            <v-icon small left>mdi-keyboard-backspace</v-icon>
            Back
          </v-btn>
        </div>
      </template>
    </template>

    <template v-slot:body>
      <v-container fluid class="px-0">
        <v-tabs
          v-model="customerTab"
          background-color="transparent"
          color="cyan"
          class="custom-tab-transparent sticky-tab-0"
        >
          <v-tab class="font-size-16 font-weight-600 px-8" href="#lead">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/home.svg')" />
            </span>
            Overview
          </v-tab>
          <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#contact-person"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg
                :src="$assetURL('media/custom-svg/contact-person.svg')"
              />
            </span>
            Contact Person
          </v-tab>
           <v-tab
            class="font-size-16 font-weight-600 px-8"
            href="#notes"
          >
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg
                :src="$assetURL('media/custom-svg/note.svg')"
              />
            </span>
            Notes
          </v-tab>

          <v-tab class="font-size-16 font-weight-600 px-8" href="#amount">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/pricing.svg')" />
            </span>
            Amount
          </v-tab>

          <v-tab class="font-size-16 font-weight-600 px-8" href="#attachment">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/attachment.svg')" />
            </span>
            Attachments
          </v-tab>

          <v-tab class="font-size-16 font-weight-600 px-8" href="#history">
            <span class="svg-icon svg-icon-lg mr-4 svg-v-list-icon">
              <inline-svg :src="$assetURL('media/custom-svg/history.svg')" />
            </span>
            History
          </v-tab>
        </v-tabs>
        <!-- <perfect-scrollbar
          :options="{ suppressScrollX: true }"
          class="scroll"
          style="max-height: 90vh; position: relative"
        > -->
        <v-tabs-items v-model="customerTab">
          <v-tab-item v-if="getPermission('lead:view')" :value="'lead'">
            <v-row justify="center">
              <v-col md="12" lg="12">
                <v-card
                  flat
                  class="custom-grey-border remove-border-radius mb-4 h-100"
                >
                  <v-card-title class="headline grey lighten-4 py-1">
                    <span
                      class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                      >Basic Information</span
                    >
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <ContactDetailOverview
                      :pageLoading="pageLoading"
                      :lead="leadArr"
                      v-on:updated="getLead"
                    ></ContactDetailOverview>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col md="12" lg="12">
                <v-card
                  flat
                  class="custom-grey-border remove-border-radius mb-4 h-100"
                >
                  <v-card-title class="headline grey lighten-4 py-1">
                    <span
                      class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                    >
                      Internal Remark</span
                    >
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <span>
                      <template v-if="leadArr.internal_remark">
                        {{ leadArr.internal_remark }}
                      </template>
                      <template v-else>
                        <em class="text-muted">no internal remark</em>
                      </template>
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>

              <v-col md="12" lg="12">
                <v-card
                  flat
                  class="custom-grey-border remove-border-radius mb-4 h-100"
                >
                  <v-card-title class="headline grey lighten-4 py-1">
                    <span
                      class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase"
                    >
                      Email Reply</span
                    >
                  </v-card-title>
                  <v-card-text class="p-6 font-size-16">
                    <span>
                      <template v-if="leadArr.email_reply">
                        {{ leadArr.email_reply }}
                      </template>
                      <template v-else>
                        <em class="text-muted">no email reply</em>
                      </template>
                    </span>
                  </v-card-text>
                </v-card>
              </v-col>

              <!--  <v-col md="12" lg="12">
                    <v-card flat class="custom-grey-border remove-border-radius mb-4 h-100">
                          <v-card-title class="headline grey lighten-4 py-1">
                            <span class="font-weight-700 custom-headline color-custom-blue font-size-16 text-uppercase">
                            Extra Information</span>
                          </v-card-title>
                          <v-card-text class="p-6 font-size-16">
                            <v-skeleton-loader
                              class="custom-skeleton"
                              v-if="!leadArr"
                              type="text@5"
                            >
                             </v-skeleton-loader>

                            <table v-else class="width-100">
                              <tr>
                                  <td
                                    width="200"
                                    class="py-1 font-size-18 font-weight-500"
                                  >
                                    Public
                                  </td>
                                  <td class="font-size-18 text-lowercase">
                                      <template v-if="leadArr.is_public">
                                        <span class="text-h6 green--text">Yes</span>
                                      </template>
                                      <span v-else class="text-h6 red--text">No</span>
                                    
                                  </td>
                              </tr>

                              <tr>
                                  <td
                                    width="200"
                                    class="py-1 font-size-18 font-weight-500"
                                  >
                                    Contacted Today
                                  </td>
                                  <td class="font-size-18 text-lowercase">
                                      <template v-if="leadArr.contacted_today">
                                        <span class="text-h6 green--text">Yes</span>
                                      </template>
                                      <span v-else class="text-h6 red--text">No</span>
                                    
                                  </td>
                              </tr>
                            </table>
                           
                          </v-card-text>
                    </v-card>
                </v-col> -->

              <CustomFormDetail
                v-if="leadArr.id"
                module="customer"
                :module-id="leadArr.id"
              />
            </v-row>
          </v-tab-item>
          <v-tab-item :value="'contact-person'">
            <v-expansion-panels v-if="false" v-model="panel" inset>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <template v-slot:default="{ open }">
                    <v-row no-gutters>
                      <v-col cols="6" class="margin-auto">
                        <h2
                          class="margin-auto color-custom-blue font-weight-600"
                        >
                          Contact Persons
                        </h2>
                      </v-col>
                      <v-col cols="6">
                        <span v-if="open" key="0">
                          <template
                            v-if="getPermission('contact-person:create')"
                          >
                            <span class="float-right">
                              <v-skeleton-loader
                                class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                v-if="pageLoading"
                                type="button"
                                height="28"
                                width="200"
                              >
                              </v-skeleton-loader>
                              <v-btn
                                depressed
                                v-else
                                class="mx-2 mr-4 custom-bold-button white--text"
                                color="cyan"
                                small
                                v-on:click.native.stop="
                                  personId = 0;
                                  personDialog = true;
                                "
                              >
                                <v-icon dark left>mdi-plus</v-icon>Create
                                Contact Person
                              </v-btn>
                            </span>
                          </template>
                          <template v-if="personSelectedRows.length > 0">
                            <template
                              v-if="getPermission('contact-person:update')"
                            >
                              <span class="float-right">
                                <v-skeleton-loader
                                  class="custom-skeleton d-inline-block custom-skeleton-full-width"
                                  v-if="pageLoading"
                                  type="button"
                                  height="28"
                                  width="150"
                                >
                                </v-skeleton-loader>
                                <v-menu
                                  v-else
                                  :close-on-click="true"
                                  bottom
                                  content-class="custom-menu-list"
                                  offset-y
                                >
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      depressed
                                      v-bind="attrs"
                                      v-on="on"
                                      class="mx-2 custom-bold-button white--text"
                                      color="cyan"
                                      small
                                    >
                                      <v-icon small dark left
                                        >mdi-chevron-down</v-icon
                                      >Bulk Action
                                    </v-btn>
                                  </template>
                                  <v-list>
                                    <template
                                      v-for="(item, index) in personBulkActions"
                                    >
                                      <template>
                                        <template
                                          v-if="
                                            (item.action == 'default' &&
                                              personSelectedRows.length == 1) ||
                                            item.action != 'default'
                                          "
                                        >
                                          <v-list-item
                                            :key="index"
                                            link
                                            v-on:click="
                                              updateCustomerPerson(item)
                                            "
                                          >
                                            <v-list-item-title
                                              class="font-weight-400 my-2 font-size-14"
                                              >{{
                                                item.title
                                              }}</v-list-item-title
                                            >
                                          </v-list-item>
                                        </template>
                                      </template>
                                    </template>
                                  </v-list>
                                </v-menu>
                              </span>
                            </template>
                          </template>
                        </span>
                      </v-col>
                    </v-row>
                  </template>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <ContactPerson
                    :pageLoading="pageLoading"
                    :lead="leadArr"
                    v-on:selectLead="showUpdateDialog"
                    v-on:selectedRows="updatePersonSelectedRows"
                  ></ContactPerson>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-row no-gutters>
              <v-col cols="6" class="margin-auto">
                <h2 class="margin-auto color-custom-blue font-weight-600">
                  Contact Persons
                </h2>
              </v-col>
              <v-col cols="6">
                <span>
                  <template v-if="getPermission('contact-person:create')">
                    <span class="float-right">
                      <v-skeleton-loader
                        class="custom-skeleton d-inline-block custom-skeleton-full-width"
                        v-if="pageLoading"
                        type="button"
                        height="28"
                        width="200"
                      >
                      </v-skeleton-loader>
                      <v-btn
                        depressed
                        v-else
                        class="mx-2 mr-4 custom-bold-button white--text"
                        color="cyan"
                        small
                        v-on:click.native.stop="
                          personId = 0;
                          personDialog = true;
                        "
                      >
                        <v-icon dark left>mdi-plus</v-icon>Create Contact Person
                      </v-btn>
                    </span>
                  </template>
                  <template v-if="personSelectedRows.length > 0">
                    <template v-if="getPermission('contact-person:update')">
                      <span class="float-right">
                        <v-skeleton-loader
                          class="custom-skeleton d-inline-block custom-skeleton-full-width"
                          v-if="pageLoading"
                          type="button"
                          height="28"
                          width="150"
                        >
                        </v-skeleton-loader>
                        <v-menu
                          v-else
                          :close-on-click="true"
                          bottom
                          content-class="custom-menu-list"
                          offset-y
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                              depressed
                              v-bind="attrs"
                              v-on="on"
                              class="mx-2 custom-bold-button white--text"
                              color="cyan"
                              small
                            >
                              <v-icon small dark left>mdi-chevron-down</v-icon
                              >Bulk Action
                            </v-btn>
                          </template>
                          <v-list>
                            <template
                              v-for="(item, index) in personBulkActions"
                            >
                              <template>
                                <template
                                  v-if="
                                    (item.action == 'default' &&
                                      personSelectedRows.length == 1) ||
                                    item.action != 'default'
                                  "
                                >
                                  <v-list-item
                                    :key="index"
                                    link
                                    v-on:click="updateCustomerPerson(item)"
                                  >
                                    <v-list-item-title
                                      class="font-weight-400 my-2 font-size-14"
                                      >{{ item.title }}</v-list-item-title
                                    >
                                  </v-list-item>
                                </template>
                              </template>
                            </template>
                          </v-list>
                        </v-menu>
                      </span>
                    </template>
                  </template>
                </span>
              </v-col>
            </v-row>
            <v-col cols="12" class="pa-0">
              <ContactPerson
                :pageLoading="pageLoading"
                :lead="leadArr"
                v-on:selectLead="showUpdateDialog"
                v-on:selectedRows="updatePersonSelectedRows"
                v-on:refress:data="getLead"
                v-on:success="getLead"
              ></ContactPerson>
            </v-col>
          </v-tab-item>

          <v-tab-item v-if="getPermission('lead:view')" :value="'notes'">
              <div style="padding-bottom: 60px">
                <ChatNote
                  v-if="customerTab === 'notes' && leadArr.id"
                  :inbox-offset="420"
                  hide-horizontal-scroll
                  :relatedId="Number(lead)"
                  :relatedType="'lead'"
                  :documentTypes="50"
                  create-url="lead-notes"
                  get-url="lead-notes"
                ></ChatNote>
              </div>
          </v-tab-item>

          <v-tab-item v-if="getPermission('customer:view')" :value="'amount'">
            <Amount :lead="leadArr" :pageLoading="pageLoading"></Amount>
          </v-tab-item>

          <v-tab-item v-if="getPermission('history:view')" :value="'history'">
            <InternalHistoryDetail
              type="lead"
              :type_id="leadArr.id"
            ></InternalHistoryDetail>
          </v-tab-item>
          <v-tab-item
            v-if="getPermission('customer:view')"
            :value="'attachment'"
          >
            <div class="service-detail-height">
              <AdditionalDocuments
                :type-id="leadArr.id"
                class="mx-0 mb-3"
                type-text="Lead Attachments"
                :type="20"
                :extensive="false"
              ></AdditionalDocuments>
            </div>
          </v-tab-item>
        </v-tabs-items>
        <!-- </perfect-scrollbar> -->

        <FullDialog
          v-if="notesDialog"
          :dialog="notesDialog"
          content-class="testdata"
        >
          <template v-slot:title
            >{{ leadArr.display_name }}(
            {{ leadArr.barcode }}
            ) Notes
            <v-spacer></v-spacer>
            <v-btn
              class="text-white"
              color="red darken-4"
              depressed
              tile
              v-on:click="notesDialog = false"
            >
              Close
            </v-btn>
          </template>
          <template v-slot:body>
            <ChatNote
              v-if="notesDialog"
              :relatedId="Number(customer)"
              :relatedType="'customer'"
              :documentTypes="33"
              create-url="customer-notes"
              get-url="customer-notes"
            ></ChatNote>
          </template>
          <!-- <template v-slot:action>
				<v-btn class="text-white" color="red darken-4" depressed tile v-on:click="closeDialog">
					Close
				</v-btn>
			</template> -->
        </FullDialog>
      </v-container>
    </template>
    <template v-slot:footer>
      <Dialog
        v-if="detailDialog"
        :commonDialog="detailDialog"
        :dialogWidth="getContactDialogWith"
      >
        <template v-slot:title>Update lead Details </template>
        <template v-slot:body>
          <v-form
            :class="{
              'pointer-events-none': !getPermission('lead:update'),
            }"
            ref="leadDetailForm"
            v-model.trim="detailForm"
            lazy-validation
            v-on:submit.stop.prevent="onDetailSubmit('leadDetailForm')"
          >
            <DialogBasicDetails
              :detail="leadArr"
              :isDialog="true"
              @update:detail="handleBasicDetailUpdate"
              :options="vOptions"
            >
            </DialogBasicDetails>
          </v-form>
        </template>
        <template v-slot:action>
          <template v-if="getPermission('lead:update')">
            <v-btn
              depressed
              :disabled="!detailForm || formLoading"
              :loading="formLoading"
              class="mx-2 custom-bold-button white--text"
              color="cyan"
              v-on:click="onDetailSubmit('leadDetailForm')"
              >Update
            </v-btn>
          </template>
          <v-btn
            depressed
            :disabled="formLoading"
            class="mx-2 custom-grey-border custom-bold-button"
            v-on:click="masterDialogClose"
            >Close
          </v-btn>
        </template>
      </Dialog>
      <template v-if="personDialog">
        <DialogContactPersons
          disable-one
          v-model="leadArr.persons"
          :person-dialog="personDialog"
          :do-update="!!+personId"
          :do-save="!!!+personId"
          :person-id="personId"
          :leadId="leadArr.id"
          :lead="leadArr"
          v-on:close="personDialog = false"
          v-on:update:person="getLead"
        ></DialogContactPersons>
      </template>

      <template v-if="personSingleDialog">
        <DialogIndividualContactPersons
          disable-one
          v-model="leadArr.persons"
          :person-dialog="personSingleDialog"
          :do-update="!!+personId"
          :do-save="!!!+personId"
          :person-id="personId"
          :customerId="leadArr.id"
          :customer="leadArr"
          v-on:close="personSingleDialog = false"
          v-on:update:person="getLead"
          :options="vOptions"
        ></DialogIndividualContactPersons>
      </template>

      <template>
        <template v-if="transaction_contact_person_dialog">
          <CustomerPersonDialog
            :customerPersonDialog="transaction_contact_person_dialog"
            :customer="transaction_customer"
            v-on:closeDialog="closeDialog"
            v-on:resetAll="resetAll"
            v-on:selectCustomerPerson="selectCustomerPerson"
          >
          </CustomerPersonDialog>
        </template>
      </template>
    </template>
  </DetailTemplate>
</template>

<script>
import FullDialog from "@/view/components/FullDialog";

import ChatNote from "@/view/pages/partials/ChatNote";
import CommonMixin from "@/core/plugins/common-mixin";
import ValidationMixin from "@/core/plugins/validation-mixin";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  CLEAR_ERROR,
  GET,
  POST,
  PATCH,
} from "@/core/services/store/request.module";

import ContactDetail from "@/view/pages/lead-new/detail/overview/Contact-Detail.vue";
import ContactDetailOverview from "@/view/pages/lead-new/detail/overview/Contact-Detail-Overview.vue";
import Amount from "@/view/pages/lead-new/detail/overview/Amount.vue";
import ContactPerson from "@/view/pages/lead-new/detail/overview/Contact-Person.vue";
import DialogIndividualContactPersons from "@/view/pages/customer/create-or-update/Update-Single-Person-Individual-Customer";
import Dialog from "@/view/pages/partials/Dialog.vue";
import DetailTemplate from "@/view/pages/partials/Detail-Template.vue";
import DialogBasicDetails from "@/view/pages/lead-new/create-or-update/Basic-Details.vue";
import CustomerMixin from "@/core/plugins/customer-mixin";
import PatchCustomerMixin from "@/core/lib/customer/patch.customer.mixin";
import CustomerPersonDialog from "@/view/pages/partials/Select-Customer-Person.vue";

import InternalHistoryDetail from "@/view/pages/partials/Detail/Internal-History-Detail.vue";
import DialogContactPersons from "@/view/pages/lead-new/create-or-update/Create-Contact-Person";

import CustomFormDetail from "@/view/pages/custom-field-v2/CustomFormDetail.vue";
import { mapGetters } from "vuex";

import AdditionalDocuments from "@/view/pages/engineer/Additional-Documents";

export default {
  mixins: [CommonMixin, ValidationMixin, CustomerMixin, PatchCustomerMixin],
  name: "customer-detail",
  title: "Customer",
  data() {
    return {
      notesDialog: false,
      customerTab: "lead",
      basicDetails: {},
      persons: [],
      lead: 0,
      invoiceId: 0,
      serviceFormDialog: false,
      pageLoading: true,
      resetPasswordDialog: false,
      resetPasswordLoading: false,
      deleteDialog: false,
      leadArr: {},
      options: {},
      createTransactions: [],
      tabs: [
        {
          title: "Overview",
          icon: "mdi-phone",
          key: "lead",
          disabled: false,
        },
        {
          title: "Contact Person",
          icon: "mdi-phone",
          key: "contact-person",
          disabled: false,
        },

        {
          title: "History",
          icon: "mdi-credit-card",
          key: "history",
          disabled: false,
        },
      ],
      leadOptions: [
        {
          title: "Convert to Customer",
          action: "convert_to_customer",
        },
      ],
      customerMoreAction: [
        {
          title: "Mark as Active",
          icon: "mdi-check-all",
          action: "active",
        },
        {
          title: "Mark as In-Active",
          icon: "mdi-check-all",
          action: "inactive",
        },
      ],
      panel: 0,
      personSelectedRows: [],
      propertySelectedRows: [],
      contactDetail: {},
      contactPerson: [],
      detailForm: true,
      detailDialog: false,
      formLoading: false,
      personId: 0,
      personForm: true,
      personDialog: false,
      personSingleDialog: false,
      propertyId: 0,
      propertyForm: true,
      propertyDialog: false,
      billingForm: true,
      billingDialog: false,
    };
  },
  components: {
    ContactDetail,
    ContactDetailOverview,
    ContactPerson,
    Dialog,
    DialogBasicDetails,
    DialogContactPersons,
    DialogIndividualContactPersons,
    DetailTemplate,
    CustomerPersonDialog,
    InternalHistoryDetail,
    CustomFormDetail,
    AdditionalDocuments,
    ChatNote,
    FullDialog,
    Amount,
  },
  watch: {
    panel() {
      this.masterDialogClose();
    },
    
  },
  methods: {
    handleBasicDetailUpdate(val) {
      const { persons, ...rest } = val;
      this.basicDetails = { ...rest };
      this.persons = [...persons];
    },

    createTransaction(lead, param) {
      const _this = this;
      const transaction_type = _this.lodash.toString(param);

      if (transaction_type === "convert_to_customer") {
        _this.$router.push(
          _this.getDefaultRoute("customer.create", {
            query: {
              lead: lead.id,
            },
          })
        );
      }
    },

    async onDetailSubmit(formRef) {
      const _this = this;

      try {
        if (!_this.$refs[formRef].validate()) {
          return false;
        }

        _this.pageLoading = true;
        _this.formLoading = true;
        _this.$store.dispatch(CLEAR_ERROR, {});

        let formData = new Object();

        if (_this.lodash.isEmpty(_this.basicDetails) === false) {
          for (let key in _this.basicDetails) {
            formData[key] = _this.basicDetails[key];
          }
        }

        formData.persons = _this.persons;

        if (_this.lodash.isEmpty(formData) === false) {
          await _this.$store.dispatch(POST, {
            url: "leads/" + _this.lead,
            data: formData,
          });
        }
        _this.getLead();
      } catch (error) {
        _this.formLoading = false;
        _this.pageLoading = false;
        //ErrorEventBus.$emit("update:error", InitializeError(error));
      }
    },

    pushToVisit() {
      const _this = this;
      _this.$router.push(
        _this.getDefaultRoute("job.create", {
          query: {
            customer: _this.transaction_customer,
            type: this.jobType,
          },
        })
      );
    },

    getLead() {
      this.pageLoading = true;
      this.$store
        .dispatch(GET, {
          url: `leads/${this.lead}`,
        })
        .then((response) => {
          this.leadArr = response.data;
          const { persons, ...rest } = this.leadArr;
          this.basicDetails = { ...rest };
          this.persons = [...persons];

          this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Lead", route: "lead" },
            { title: "Detail" },
            { title: this.leadArr.barcode },
          ]);
          this.masterDialogClose();
        })
        .catch(() => {
          this.goBack();
        })
        .finally(() => {
          this.pageLoading = false;
          this.formLoading = false;
        });
    },

    resetPassword() {
      this.$refs.passwordUpdateRef.onSubmit();
    },
    resetPasswordSuccess() {
      this.resetPasswordDialog = false;
    },
    rereshDetails() {
      let _this = this;
      _this
        .getCustomer()
        .then((response) => {
          _this.leadArr = response;
          _this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Customer", route: "customer" },
            { title: "Detail" },
            { title: response.barcode },
          ]);
        })
        .catch((error) => {
          _this.logError(error);
          _this.$router.go(-1);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    updateMoreAction(action) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
      }
      _this
        .patchCustomer(_this.customer, formData)
        .then(() => {
          _this.getCustomer().then((response) => {
            _this.leadArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    activeInactive(data) {
      const _this = this;
      if (data.activated == false) {
        data.activated = 0;
      } else {
        data.activated = 1;
      }
      _this.$store
        .dispatch(PATCH, {
          url: `single-customer/${data.activated}/${data.id}`,
          data: {
            id: data.id,
            status: data.activated,
          },
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.getCustomer();
        });
    },
    updatePropertyAddress(param) {
      this.propertyAddress = param;
    },
    updateBillingAddress(param) {
      this.billingAddress = param;
    },
    updateContactDetail(param) {
      this.contactDetail = param;
    },
    updateContactPerson(param) {
      this.contactPerson = param;
    },
    updateNotification(param) {
      this.notification = param;
    },
    updatePersonSelectedRows(param) {
      this.bulkRows = { persons: param };
      this.personSelectedRows = param;
    },
    updatePropertySelectedRows(param) {
      this.bulkRows = { property: param };
      this.propertySelectedRows = param;
    },
    updateCustomerPerson({ action }) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
        case "default":
          formData.default = 1;
          break;
      }
      _this
        .patchCustomerContactPerson(
          _this.customer,
          _this.personSelectedRows,
          formData
        )
        .then(() => {
          _this.getCustomer().then((response) => {
            _this.leadArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    updateCustomerProperty({ action }) {
      const _this = this;
      let formData = {};
      switch (action) {
        case "active":
          formData.status = 1;
          break;
        case "inactive":
          formData.status = 0;
          break;
      }
      _this
        .patchCustomerProperty(
          _this.customer,
          _this.propertySelectedRows,
          formData
        )
        .then(() => {
          _this.getCustomer().then((response) => {
            _this.leadArr = response;
          });
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    showUpdateDialog(param) {
      this.personId = param;
      this.$nextTick(() => {
        this.personDialog = true;
      });
    },

    masterDialogClose() {
      this.$root.$emit("clearSelection", true);
      this.personSelectedRows = [];
      this.propertySelectedRows = [];
      this.basicDetail = {};
      this.contactPerson = [];
      this.detailForm = true;
      this.detailDialog = false;
      this.formLoading = false;
      this.personId = 0;
      this.personForm = true;
      this.personDialog = false;
      this.personSingleDialog = false;
      this.deleteDialog = false;
    },
  },

  mounted() {
    const _this = this;

    _this.checkTransactionPermission();
    _this.checkTabPermission();
    _this.getLead();
  },

  created() {
    const _this = this;
    _this.lead = _this.$route.params.id;

    if (!_this.lead || _this.lead <= 0) {
      _this.$router.go(-1);
    }

    if (_this.$route.query && _this.$route.query.tab) {
      _this.customerTab = _this.$route.query.tab;
    }
  },
  computed: {
    ...mapGetters(["gActiveFormFields", "vOptions"]),
    getContactDialogWith() {
      if (window.innerWidth > 1240) {
        return 1320;
      }
      return window.innerWidth - 300;
    },

    getPageTitle() {
      let result = [];
      if (this.lodash.isEmpty(this.leadArr) === false) {
        if (this.leadArr.display_name) {
          result.push(this.leadArr.display_name);
        }

        /*
        if (this.leadArr.barcode) {
          result.push(this.leadArr.barcode);
        }
        */
      }
      return result.join(" • ");
    },
  },
};
</script>
